import { useState } from "react";
import { Link, useLocation } from "react-router-dom";
import CategoriesMenu from "./CategoriesMenu";

const NavigationMenu = ({ language, categoriesQuery }) => {
  const [menuOpen, setMenuOpen] = useState(false);
  const location = useLocation();
  const path = location.pathname;
  const searchParams = new URLSearchParams(location.search);
  const gender = searchParams.get("gender");
  const type = searchParams.get("type");

  return (
    <div>
      {/* Mobile Menu */}
      <div className={`lg:hidden ${menuOpen ? "block" : "hidden"} mt-2 px-4`}>
        <ul className="flex flex-col gap-2">
          <CategoriesMenu categoriesQuery={categoriesQuery} />
          <li className={`${path === "/mens" ? "active" : ""}`}>
            <a href="/mens" className="sub-menu-item block py-1">
              {language === "ka" ? "მამაკაცები" : "Men's"}
            </a>
          </li>
          <li className={`${path === "/womens" ? "active" : ""}`}>
            <a href="/womens" className="sub-menu-item block py-1">
              {language === "ka" ? "ქალები" : "Women's"}
            </a>
          </li>
          <li className={`${path === "/kids" ? "active" : ""}`}>
            <a href="/kids" className="sub-menu-item block py-1">
              {language === "ka" ? "ბავშვები" : "Kids"}
            </a>
          </li>
          <li className={`${path === "/sale" ? "active" : ""}`}>
            <a href="/sale" className="sub-menu-item block py-1">
              {language === "ka" ? "ფასდაკლება" : "Sale"}
            </a>
          </li>
          <li className={`${path === "/accessories" ? "active" : ""}`}>
            <a href="/accessories" className="sub-menu-item block py-1">
              {language === "ka" ? "აქსესუარები" : "Accessories"}
            </a>
          </li>

        </ul>
      </div>

      {/* Desktop Menu */}
      <div className="hidden lg:block">
        <ul className="navigation-menu flex flex-nowrap">
          <CategoriesMenu categoriesQuery={categoriesQuery} />
          <li className={`${gender === "2" ? "active" : ""}`}>
            <Link to="/shop?gender=2" className="px-0 sub-menu-item">
              {language === "ka" ? "მამაკაცები" : "Men's"}
            </Link>
          </li>
          <li className={`${gender === "1" ? "active" : ""}`}>
            <Link to="/shop?gender=1" className="px-0 sub-menu-item">
              {language === "ka" ? "ქალები" : "Women's"}
            </Link>
          </li>
          <li className={`${gender === "3" ? "active" : ""}`}>
            <Link to="/shop?gender=3" className="px-0 sub-menu-item">
              {language === "ka" ? "ბავშვები" : "Kids"}
            </Link>
          </li>
          <li className={`${type === "sales" ? "active" : ""}`}>
            <Link to="/shop?type=sales" className="px-0 sub-menu-item">
              {language === "ka" ? "ფასდაკლება" : "Sale"}
            </Link>
          </li>
          <li className={`${!gender && !type && path === "/shop" ? "active" : ""}`}>
            <Link to="/shop" className="px-0 sub-menu-item">
              {language === "ka" ? "აქსესუარები" : "Accessories"}
            </Link>
          </li>
        </ul>
      </div>
    </div>
  );
};

export default NavigationMenu;
